let apiHost = import.meta.env.VITE_API_URL || 'https://devapi.servcraft.co.za/api'
if (apiHost.indexOf('localhost') > 0 && !apiHost.endsWith('api')) apiHost = apiHost + '/api'

let managerHost = import.meta.env.VITE_MANAGER_URL || 'https://managerapi.servcraft.co.za/api'
if (managerHost.indexOf('localhost') > 0 && !managerHost.endsWith('api')) managerHost = managerHost + '/api'

let authHost = import.meta.env.VITE_AUTH_URL || import.meta.env.NEXT_PUBLIC_AUTH_URL || ''
// When set at build time, pins the data API host for every request, overriding
// both the dev fallback and the per-tenant apiHost cookie written at login.
// Leave unset for the default behaviour (login-driven host). Build-time only:
// Vite inlines import.meta.env.* during `npm run build`.
const pinnedApiHost = import.meta.env.VITE_PINNED_API_URL || ''

const isDebugging = () => import.meta.env.MODE === 'development'
const isDebuggingManager = () => import.meta.env.MODE === 'development'

export default { isDebugging, isDebuggingManager, apiHost, managerHost, authHost, pinnedApiHost }
